import { render, staticRenderFns } from "./TableLoadingPlaceholder.vue?vue&type=template&id=788a168a&"
import script from "./TableLoadingPlaceholder.vue?vue&type=script&lang=js&"
export * from "./TableLoadingPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports